/* 近代化資金入力種別選択 */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Container, Button } from 'react-bootstrap';
import axios from '../../axios';
import { handleBrowserBack } from '../../BrowserBack';
import Heading from '../../molecules/Heading';
import Paragraph from '../../molecules/Paragraph';
import TransitionButton from '../../molecules/TransitionButton';
import LoadingModal from '../../molecules/LoadingModal';
import { KWANKGM04210A01 } from '../../const/api_modules';
import { status_code_list } from '../../Const';

const ModernizationFundsInputTypeSelect: React.FC = () => {
  // 借入申込希望書兼経営改善資金計画書ボタンの活性制御
  const [enabled_planning_document, setEnabledPlanningDocument] = useState(false);
  // 借入申込書ボタンの活性制御
  const [enabled_application, setEnabledApplication] = useState(false);

  const [is_loading, setIsLoading] = useState(false);

  const node = document.getElementById('modernization-funds-input-type-select');
  const r_id = node?.dataset.r_id;
  const r_cd = node?.dataset.r_cd;
  const application_status = node?.dataset.application_status;

  // リファラから戻り先のステータスを取得する
  const refere = document.referrer;
  let refere_status = refere.match(/[0-9]+$/);

  // TODO モックはAPIが連携されたら削除する
  const mock = {
    data: {
      result: true,
      message: '',
      list: {
        mp_button: true,
        ma_button: false,
      },
    },
  };

  useEffect(() => {
    // ブラウザバック制御
    handleBrowserBack();
    // 初期処理
    requestModule();
  }, []);

  const requestModule = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/common`,
        {
          reception_id: r_id,
          reception_cd: r_cd,
          module_name: KWANKGM04210A01,
          is_json: true,
        }
      );

      if (!response.data.result) {
        throw { response: response };
      }

      setEnabledPlanningDocument(response.data.list.mp_button);
      setEnabledApplication(response.data.list.ma_button);
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  // 借入申込希望書兼経営改善資金計画書ボタン押下時の処理
  const handleClickPlanningDocument = () => {
    location.replace(
      `${location.origin}${process.env.MIX_MOCK_URL}/reception/${r_cd}/${r_id}/${application_status}?item_id=32`
    );
  };

  // 借入申込書ボタン押下時の処理
  const handleClickApplication = () => {
    location.replace(
      `${location.origin}${process.env.MIX_MOCK_URL}/reception/${r_cd}/${r_id}/${application_status}?item_id=33`
    );
  };

  // 戻るボタン押下時の処理
  const handkeClickReturn = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_reception_status`,
        {
          r_id: r_id,
          r_cd: r_cd,
        }
      );

      // 案件ステータスが2310, 2330, 2400, 2500, 2610, 2910の場合は、KWANKGM04330_近代化資金案件詳細に遷移する
      if (
        Number(response.data.status) === status_code_list.borrowing_application_waiting_mp ||
        Number(response.data.status) === status_code_list.borrowing_application_linked_mp ||
        Number(response.data.status) === status_code_list.borrowing_application_check ||
        Number(response.data.status) === status_code_list.borrowing_application_disagreement ||
        Number(response.data.status) === status_code_list.borrowing_application_waiting_mdn ||
        Number(response.data.status) === status_code_list.borrowing_application_doing_mdn
      ) {
        location.replace(
          `${location.origin}${process.env.MIX_MOCK_URL}/reception/${r_cd}/${r_id}/${response.data.status}`
        );
        return;
      }

      // 遷移元URLのステータスが2500の場合、ステータス2300の画面に遷移する
      const referer = sessionStorage.getItem('modernization_funds_input_type_select_referer');
      if (referer?.indexOf('/2500') !== -1) {
        location.replace(referer !== null ? referer?.replace('/2500', '/2300') : '');
        return;
      }

      // 上記でない場合はSessionStorageに保持しているURLに遷移する
      location.replace(
        sessionStorage.getItem('modernization_funds_input_type_select_referer') ?? ''
      );
    } catch (error) {
      alert(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="content">
        <Heading label="入力種別選択" size="l" />
        <Container>
          <Paragraph label="入力種別を選択して下さい" is_paragraph={true} />
          <div>
            農業近代化資金の申込には、借入申込希望書兼経営改善資金計画書と借入申込書の双方の提出が必要です。
            <br/>
            入力が必要な書類を選択して下さい。
          </div>
          <div className="center-button mt-5">
            <Button
              className={`btn-max btn-main-color ${!enabled_planning_document && 'btn-disabled'}`}
              onClick={handleClickPlanningDocument}
              variant=""
            >
              借入申込希望書兼経営改善資金計画書
            </Button>
          </div>
          <div className="center-button mt-5">
            <Button
              className={`btn-max btn-main-color ${!enabled_application && 'btn-disabled'}`}
              onClick={handleClickApplication}
              variant=""
            >
              借入申込書
            </Button>
          </div>
          <TransitionButton label="戻る" btn_class="btn-return" handleClick={handkeClickReturn} />
        </Container>
      </div>
      <LoadingModal show={is_loading} />
    </div>
  );
};

if (document.getElementById('modernization-funds-input-type-select')) {
  ReactDOM.render(
    <ModernizationFundsInputTypeSelect />,
    document.getElementById('modernization-funds-input-type-select')
  );
}
